import React from 'react';
import PropTypes from 'prop-types';

import { priceFormat, getFlowType, isPreorder } from '../../../Helpers/index';
import CommonSection from './commonSection';

const ShippingDetails = ({ shippingDetails, cartDetails, displayText, shippingText, pageName, estimatedDeliveryDate, isMinicartSection = false }) => {
  const orderDetails = cartDetails?.orderDetailsView || {};
  const flowType = getFlowType();
  const installationType = orderDetails?.installType || '';
  let showInstall = installationType && installationType.toLowerCase().includes('self');
  if (!installationType && flowType === 'LTE') {
    showInstall = true;
  }
  const showSubText = !isPreorder() && pageName === 'cart' && !(shippingDetails && shippingDetails[0] && shippingDetails[0].shippingDescription);

  // to display the only in cart page with subtitle "you can change this during checkout"
  const isCartSection = pageName === 'cart' || pageName === 'orderreview' || pageName === 'confirmation';
  const isShippingDetails = shippingDetails !== null && shippingDetails !== undefined && shippingDetails !== '';

  return (
    <>
      {showInstall && isShippingDetails && isCartSection && isMinicartSection && (
        <CommonSection
          leftValueText={
            shippingDetails && shippingDetails[0] && shippingDetails[0].shippingDescription
              ? `${shippingDetails[0].shippingDescription} shipping`
              : displayText || 'Two-day shipping'
          }
          rightValueText={priceFormat(shippingDetails[0] && shippingDetails[0].shippingCost ? shippingDetails[0].shippingCost : '$0.00')}
          id="Shipping Info"
          className="normalStyle"
          subTitle={
            showSubText
              ? shippingDetails.displayText
                ? shippingDetails.displayText
                : shippingText
              : isPreorder() && estimatedDeliveryDate && `${estimatedDeliveryDate} ${orderDetails && orderDetails.preOrderInServiceDate}`
          }
        />
      )}

      {isShippingDetails && shippingDetails?.[0]?.shippingDescription && !isCartSection && (
        <CommonSection
          leftValueText={shippingDetails[0].shippingDescription || ''}
          rightValueText={priceFormat(shippingDetails[0].shippingCost ? shippingDetails[0].shippingCost : '$0.00')}
          id="Shipping Info"
          className="normalStyle"
        />
      )}
    </>
  );
};

ShippingDetails.propTypes = {
  shippingDetails: PropTypes.array,
  cartDetails: PropTypes.object,
  displayText: PropTypes.string,
  shippingText: PropTypes.string,
  pageName: PropTypes.string,
  estimatedDeliveryDate: PropTypes.string,
  isMinicartSection: PropTypes.bool,
};
export default ShippingDetails;
